import { getAuroraJurisdiction } from '../../../../data/contactCenter/aurora/dropDownOptions';

/** Skilling sheet value `1` means the agent is staffed for that jurisdiction. */
export function hasJurisdictionSkillAccess(skillValue) {
  return skillValue === 1 || skillValue === '1';
}

export function getJurisdictionSkillKey(jurisdictionLabel) {
  return getAuroraJurisdiction(jurisdictionLabel)?.skillKey ?? null;
}

/**
 * ES/Aurora (`cs_skills`) wins when the jurisdiction has a `csSkillKey`.
 * Otherwise fall back to Retailer (`retailer_skills`) via `skillKey`.
 */
export function canAccessJurisdiction(
  jurisdictionLabel,
  retailerSkills,
  csSkills,
) {
  const jurisdiction = getAuroraJurisdiction(jurisdictionLabel);
  if (!jurisdiction) {
    return false;
  }

  if (jurisdiction.csSkillKey) {
    return hasJurisdictionSkillAccess(csSkills?.[jurisdiction.csSkillKey]);
  }

  if (!jurisdiction.skillKey || !retailerSkills) {
    return false;
  }

  return hasJurisdictionSkillAccess(retailerSkills[jurisdiction.skillKey]);
}
